var _defs, _path, _line, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack172({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.26,12a3,3,0,1,0,3-3,3,3,0,1,1,3-3"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 6.24,
    y1: 1,
    x2: 6.24,
    y2: 15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.39,14l.44-.06a1,1,0,0,0,.26.54.64.64,0,0,0,.44.17.73.73,0,0,0,.53-.22.72.72,0,0,0,.21-.53.65.65,0,0,0-.2-.5.69.69,0,0,0-.5-.2,1.4,1.4,0,0,0-.31.05l.05-.38h.07a.9.9,0,0,0,.51-.15.48.48,0,0,0,.22-.45.54.54,0,0,0-.16-.4.61.61,0,0,0-.43-.16.57.57,0,0,0-.42.17.72.72,0,0,0-.22.48l-.44-.08a1.1,1.1,0,0,1,.36-.68,1,1,0,0,1,.71-.25,1.08,1.08,0,0,1,.54.13.9.9,0,0,1,.38.34.87.87,0,0,1,.13.46.8.8,0,0,1-.12.43,1,1,0,0,1-.37.3.86.86,0,0,1,.49.3.93.93,0,0,1,.18.58,1.07,1.07,0,0,1-.34.79,1.21,1.21,0,0,1-.87.33,1.12,1.12,0,0,1-.78-.28A1.09,1.09,0,0,1,10.39,14Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack172);
export default __webpack_public_path__ + "static/media/Symbolpack_1_72.da01a6f3d92b7060a1d1131afcc3ed4d.svg";
export { ForwardRef as ReactComponent };